export default {
    name: "breadCrumbs",
    
    props: {
        links: {
            type: Array,
            require: true,
        }
    },
}